"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayCustomMap = exports.Vector3 = void 0;
class Vector3 {
    constructor(vec) {
        this.vec = vec;
    }
    lerp(to, t) {
        return new Vector3([this.vec[0] + (to.vec[0] - this.vec[0]) * t,
            this.vec[1] + (to.vec[1] - this.vec[1]) * t,
            this.vec[2] + (to.vec[2] - this.vec[2]) * t]);
    }
    lerpTo(to, t) {
        this.vec[0] = this.vec[0] + (to.vec[0] - this.vec[0]) * t;
        this.vec[1] = this.vec[1] + (to.vec[1] - this.vec[1]) * t;
        this.vec[2] = this.vec[2] + (to.vec[2] - this.vec[2]) * t;
        return this;
    }
    setFrom(other) {
        this.vec[0] = other[0];
        this.vec[1] = other[1];
        this.vec[2] = other[2];
        return this;
    }
}
exports.Vector3 = Vector3;
class ReplayCustomMap {
    constructor() {
        this.header = { timestamp: BigInt(0), version: 0, map: '', time: 0, name: '', steamid: '', additionalInfo: '' };
        this.frames = [];
        this.length = 0;
        this.time = 0;
    }
    addFrame(frame) {
        this.frames.push(frame);
        this.length += 1;
    }
}
exports.ReplayCustomMap = ReplayCustomMap;
